import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/crypto-cost-basis',
  component: () => import('../../routes/CryptoCostBasisCalculator.svelte'),
  card: {
    id: 'crypto-cost-basis',
    title: 'Crypto Cost Basis',
    description: 'Calculate your cryptocurrency cost basis, unrealized gains, holding period, and estimated tax liability.',
    icon: 'currency_bitcoin',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/crypto-cost-basis',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Crypto Cost Basis Calculator – Cryptocurrency Capital Gains & Tax Calculator',
    description: 'Free crypto cost basis calculator. Calculate unrealized gains/loss, holding period (long-term vs short-term), and estimated capital gains tax for Bitcoin, Ethereum, and other cryptocurrencies.',
  },
};

export default meta;
